import React from "react";
import { ChartColumnIncreasing } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ChartPanel } from "~/components/charts";
import { SourceChip } from "~/pages/product-details/tabs/sales-data-tab/components/source-chip";

export const TotalSalesChartPanel = ({
  titleBadge,
  actions,
  legend,
  footer,
  children,
}: {
  titleBadge?: React.ReactNode;
  actions?: React.ReactNode;
  legend?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  const { t } = useTranslation(["productDetails"]);
  return (
    <ChartPanel
      testId="total-sales-chart"
      icon={<ChartColumnIncreasing className="h-4 w-4" />}
      title={t("productDetails:salesData.totalSales.title")}
      titleBadge={
        <>
          <SourceChip source="mediaControl" />
          {titleBadge}
        </>
      }
      subtitle={t("productDetails:salesData.totalSales.subtitle")}
      actions={actions}
      legend={legend}
      footer={footer}
    >
      {children}
    </ChartPanel>
  );
};
